import $ from "jquery";

const MODAL_SELECTOR       = "#cardInfoModal";
const MODAL_TITLE_SELECTOR = ".modal-title";
const MODAL_BODY_SELECTOR  = ".modal-body";
var initialWidth;

const setModalContent = function(modal, title, body) {
  modal.find(MODAL_TITLE_SELECTOR).text(title);
  modal.find(MODAL_BODY_SELECTOR).html(body);
};

const linkClicked = function(e) {
  e.preventDefault();

  const $card = $(this).closest("[data-card]");
  const $modal = $(MODAL_SELECTOR);
  // Display a wider modal if high volume of content
  if ($card.hasClass("contains-template-donut-fan-chart")) {
    const $definitions = $card.find(".forecast-commentary-card-tab-container").last().find("li.definitions-button a");
    if (!$definitions.closest("li").hasClass("active")) {
      $definitions.click();
    }
    $card.find(".forecast-commentary-card-tab-container").last().find("a.anchor")[0].scrollIntoView({ behavior: "smooth" });

    return;
  } else if ($card.data("modal-body").length > 5000) {
    $modal.children(".modal-dialog").width(1000);
  } else {
    $modal.children(".modal-dialog").width(Math.min(600, initialWidth));
  }
  const title = $card.data("modal-title") || "ABOUT";
  const body = $card.data("modal-body") || "";

  setModalContent($modal, title, body);
  $modal.modal("show");
};

$(document).on("turbolinks:load", function() {
  initialWidth = $(MODAL_SELECTOR).children(".modal-dialog").width();
  $("#main-container").on("click", ".card-info-modal-link", linkClicked);
});
